export const RoleCode = {
    STUDENT: 'student',
    TEACHER: 'teacher',
    BCTSV: 'bctsv',
    BDT: 'bdt',
    BTCNS: 'btcns',
    BCSVC: 'bcsvc',
};
